@if (key_facts) {
<section class="product-key-facts-container">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-2" i18n="@@featureProductDetails-productKeyFactsHeader">Produktvorteile</h2>
        <ul>
          @for (keyFact of shownKeyFacts; track trackByKeyFacts($index, keyFact)) {
          <li [innerHtml]="keyFact | TransformLinefeed | WYSIWYGTagFilter"></li>
          }
        </ul>
        @if (keyFactsOverflowing && keyFactsExpanded) {
        <button class="expandable-button" (click)="showDefaultKeyFacts()">
          <ng-container i18n="@@featureProductDetails-expandableKeyFacts-less">- Weniger anzeigen</ng-container>
        </button>
        } @if (keyFactsOverflowing && !keyFactsExpanded) {
        <button class="expandable-button" (click)="showAllKeyFacts()">
          <ng-container i18n="@@featureProductDetails-expandableKeyFacts-more">
            + Alle anzeigen ({{ keyFacts?.length }})
          </ng-container>
        </button>
        }
      </div>
    </div>
  </div>
</section>
}
